import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import Language from './Language';
import { default as languageList } from './languageList.json';

import './style.scss';

export default function Languages({ languages, biData }) {
    _.remove(languages, { name: 'undefined' });

    if (!languages.length) { return null; }

    const langs = languages.map((language) =>
        (languageList.language_options.find((lang) => lang.value === language.name) || {}).name).toString();

    const seller_card_about_me_languages_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_languages_impression',
        data: langs
    });

    return (
        <WithImpressions value={seller_card_about_me_languages_impression} className="languages">
            <h3><I18n k="user_page_perseus.seller_profile.languages"/></h3>
            <ul>
                {languages.map((language, idx) => {
                    const languageNativeName = languageList.language_options.find((lang) => lang.value === language.name);

                    if (_.isEmpty(languageNativeName)) { return null; }

                    const languageData = {
                        name: languageNativeName.name,
                        native_name: languageNativeName.native_name,
                        level: language.level
                    };

                    return <Language language={languageData} key={idx}/>;
                })}
            </ul>
        </WithImpressions>
    );
}

Languages.propTypes = {
    languages: PropTypes.array,
    biData: PropTypes.object
};

Languages.defaultProps = {
    languages: [],
    biData: {}
};
